import React, { useState } from "react";
import ReportHeader from "./Report/ReportHeader";
import ActionMatrixSection from "./Report/ActionMatrixSection";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./GraderUI";
import {
	buildActionMatrixData,
	filterAeoActions,
	filterGeoActions,
} from "./auditUtils";

export default function AiVisibilityRecommendationView({ report }) {
	const [activeTab, setActiveTab] = useState("aeo");

	const auditId = report.audit?.id;
	const allActions = report.action_matrix?.all_actions || [];
	const aeoActions = filterAeoActions(allActions);
	const geoActions = filterGeoActions(allActions);

	return (
		<div className="ai-visibility-report-page aeo-grader-report">
			<ReportHeader
				url={report.audit?.url}
				createdAt={report.audit?.created_at}
				completedAt={report.audit?.completed_at}
				status={report.audit?.status}
				backPath="/aivisibility/recommendations"
				backLabel="Back to Recommendations List"
				title="AEO and GEO Recommendations"
			/>

			<div className="grader-report__main">
				<Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
					<div className="grader-tabs__bar">
						<TabsList>
							<TabsTrigger value="aeo">Answer Engine Optimisation</TabsTrigger>
							<TabsTrigger value="geo">Generative Engine Optimisation</TabsTrigger>
						</TabsList>
					</div>

					<TabsContent value="aeo">
						<div id="aeo-section" className="section-banner section-banner--aeo">
							<p className="section-banner__title">Answer Engine Optimisation (AEO)</p>
							<p className="section-banner__subtitle">
								Recommendations to improve AI retrieval readiness
							</p>
						</div>

						{aeoActions.length > 0 && (
							<section id="aeo-action-matrix" className="grader-section">
								<ActionMatrixSection
									auditId={auditId}
									title="AEO Action Matrix"
									subtitle="Actions to improve AI retrieval readiness"
									data={buildActionMatrixData(aeoActions)}
								/>
							</section>
						)}
					</TabsContent>

					<TabsContent value="geo">
						<div id="geo-section" className="section-banner section-banner--geo">
							<p className="section-banner__title">Generative Engine Optimisation (GEO)</p>
							<p className="section-banner__subtitle">
								Recommendations to improve brand presence in AI-generated responses
							</p>
						</div>

						{geoActions.length > 0 && (
							<section id="geo-action-matrix" className="grader-section">
								<ActionMatrixSection
									auditId={auditId}
									title="GEO Action Matrix"
									subtitle="Actions to improve brand presence in AI-generated responses"
									data={buildActionMatrixData(geoActions)}
								/>
							</section>
						)}
					</TabsContent>
				</Tabs>
			</div>
		</div>
	);
}
